<div *ngIf="!!alarm" [ngStyle]="{ display: 'flex', width: '100%', 'justify-content': 'space-between' }">
  <span class="d-flex flex-start">{{alarm.message | translate | qmReplace: alarm.translate}}</span>
  <!-- <span class="alarm-message">
    {{
      (alarm.metadata.type === "vrTrainConflict"
        ? "Equipment conflict"
        : alarm.metadata.type === "vrShiftConflict"
        ? "Personnel conflict"
        : alarm.metadata.type) | translate
    }}
  </span> -->
  <ng-container [ngSwitch]="alarm.metadata?.type">
    <div *ngSwitchCase="'vrTrainConflict'" [ngStyle]="{ width: 'fit-content' }">
      <qm-conflict-alarm-list-item
        [alarm]="alarm"
      ></qm-conflict-alarm-list-item>
    </div>
    <div *ngSwitchCase="'vrShiftConflict'" [ngStyle]="{ width: 'fit-content' }">
      <qm-conflict-alarm-list-item
        [alarm]="alarm"
      ></qm-conflict-alarm-list-item>
    </div>
    <!-- Technical alarms, currently no buttons -->
    <div *ngSwitchCase="'vrWheelAlert'" [ngStyle]="{ width: 'fit-content' }">
      <qm-technical-alarm-item [alarm]="alarm"></qm-technical-alarm-item>
    </div>
    <div *ngSwitchCase="'vrOverheating'" [ngStyle]="{ width: 'fit-content' }">
      <qm-technical-alarm-item [alarm]="alarm"></qm-technical-alarm-item>
    </div>
    <div *ngSwitchCase="'vrVoltageAlert'" [ngStyle]="{ width: 'fit-content' }">
      <qm-technical-alarm-item [alarm]="alarm"></qm-technical-alarm-item>
    </div>
    <!-- Other train alarms -->
    <div *ngSwitchDefault [ngStyle]="{ width: 'fit-content' }">
      <qm-general-train-alarm-list-item
        [alarm]="alarm">
      </qm-general-train-alarm-list-item>
    </div>
  </ng-container>
</div>
